// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"55a20adf","229":"31c643ac","427":"a6e19f25"}[chunkId] + ".chunk.js";
};